<template>
  <LoginWindow v-if="!authenticated" />
</template>

<script>
import {mapGetters} from 'vuex'
import LoginWindow from '@/components/LoginWindow'
export default {
  name: 'login',
  components: {LoginWindow},
  computed: {
    ...mapGetters({
      authenticated: 'authenticated',
    }),
  },
}
</script>

<style lang="scss">
// .has-navbar-fixed-top {
//   padding-top: 0 !important; //if no nav is present
// }
</style>
